<body>
  <app-nav-menu *ngIf="!isLoginRoute()">></app-nav-menu>
  <main class="container">
    <router-outlet></router-outlet>
  </main>
  <app-notification></app-notification>
</body>
